import Grid from 'components/core/Grid';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';

import SideBarTrust from './components/SideBarTrust';
import { ListPageEmailVerificationForm } from './components/ListPageEmailVerificationForm';
import { ListPagePasswordForm } from './components/ListPagePasswordForm';
import React from 'react';
import { useListPageModalNavigation } from './hooks/useListPageModalNavigation';
import { ListUserCreateFormUnassisted } from './components/ListUserCreateFormUnassisted';
import { ListUserCreateFormAssisted } from './components/ListUserCreateFormAssisted';
import { listFormContextInitialValues, useListModalContext } from './listModalContext';
import { AlluraErrorBoundary } from 'components/core/AlluraErrorBoundary/AlluraErrorBoundary';
import { FullScreenErrorFallback } from 'components/core/AlluraErrorBoundary/components/FullScreenErrorFallback';
import { useTermsOfServiceHTMLQuery } from 'hooks/api/core/useTermsOfServiceHTMLQuery';
import { UserRoleIDEnum } from '@alluradirect/react';

export const ListPageUserSignUpModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const { pushDefaultUrl, isAssistedSetUp, step } = useListPageModalNavigation();

  const { setListFormValues } = useListModalContext();

  // Prefetch the TOS
  useTermsOfServiceHTMLQuery({ user_type_id: UserRoleIDEnum.owner });

  const FirstStep = isAssistedSetUp ? ListUserCreateFormAssisted : ListUserCreateFormUnassisted;

  const steps = [FirstStep, ListPageEmailVerificationForm, ListPagePasswordForm];
  const safeStep = step < steps.length ? step : steps.length - 1;
  const CurrentStepComponent = steps[Number(safeStep)];

  const handleResetContext = () => {
    setListFormValues(listFormContextInitialValues);
  };

  return (
    <ConfirmationDialog
      dialogTitle="Let's Get Started"
      isDialogOpen={isOpen}
      disableBackdropClick={true}
      handleCloseDialog={() => {
        handleResetContext();
        pushDefaultUrl();
        closeModal();
      }}
      hasBottomBar={false}
      hasHeaderBar={true}
      padding={0}
      maxWidth="md"
    >
      <Grid container>
        <Grid item xs={12} md={8} p={3} pt={2}>
          <AlluraErrorBoundary Fallback={FullScreenErrorFallback}>
            <CurrentStepComponent />
          </AlluraErrorBoundary>
        </Grid>
        <SideBarTrust />
      </Grid>
    </ConfirmationDialog>
  );
};
